const index =  {
    ANNOTATOR: "ANNOTATOR",
    MANAGER: "MANAGER",
    PROJECT_ANNOTATORS: "PROJECT_ANNOTATORS",
    PROJECT_REVIEWER: "PROJECT_REVIEWER",
    PROJECT_SUPERCHECKER: "PROJECT_SUPERCHECKER",
}

export default index;